export const ECP_SELECTION_LIMIT = 1000;

export const ECP_ID_PARAM = "ecp_id";

export const ECP_TAB_PARAM = "ecp_tab";
